<template>
  <div v-if="isHorizontal" class="horizontal">
    <div class="phone"></div>
    <div class="contents">
      为了更好的体验，请打开设备旋转功能，将手机/平板竖过来
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const isHorizontal = ref(false);
onMounted(() => {
  let match = window.matchMedia("(orientation:portrait)");
  console.log(match);
  judgeHorizontal(match);
  
  match.addListener((mql) => {
    judgeHorizontal(match);
  });
});
const judgeHorizontal = (match) => {
  if (match.matches) {
    console.log("竖屏");
    isHorizontal.value = false;
  } else {
    console.log("横屏");
    isHorizontal.value = true;
  }
};
</script>

<style lang="scss" scoped>
.horizontal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  z-index: 999999;
  width: 100%;
  height: 100vh;
  background: #000;
  top: 0;
  left: 0;
  text-align: center;

  .phone {
    width: 12.5926rem;
    height: 18.8889rem;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    background-image: url(~@/assets/images/horizontal-icon.png);
    animation: rotate-horizontal 1.5s ease infinite alternate;
    transform-origin: center;
    @keyframes rotate-horizontal {
      0% {
        transform: rotate(-90deg);
      }
      30% {
        transform: rotate(-90deg);
      }
      70% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }
  .contents {
    font-size: 2.56rem;
    width: 100%;
    color: #fff;
  }
}
</style>